module.exports = __webpack_public_path__ + "img/car-bg1.17e0bf64.jpeg";